/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Upgrade_TierInputs */

const en_why_listening_upgrade_tier = /** @type {(inputs: Why_Listening_Upgrade_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to a higher tier to finish this chapter.`)
};

const es_why_listening_upgrade_tier = /** @type {(inputs: Why_Listening_Upgrade_TierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora a un plan superior para terminar este capítulo.`)
};

/**
* | output |
* | --- |
* | "Upgrade to a higher tier to finish this chapter." |
*
* @param {Why_Listening_Upgrade_TierInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_upgrade_tier = /** @type {((inputs?: Why_Listening_Upgrade_TierInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Upgrade_TierInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_upgrade_tier(inputs)
	return en_why_listening_upgrade_tier(inputs)
});